export type OptionItem<T> = T extends readonly (infer TItem)[] ? TItem : T

export type OptionRecord = Record<string, unknown>

function isOptionRecord(value: unknown): value is OptionRecord {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function toOptionRecord(value: unknown): OptionRecord | undefined {
  return isOptionRecord(value) ? value : undefined
}

export function toOptionArray<TOption extends object>(value: TOption | TOption[] | undefined): TOption[] {
  if (Array.isArray(value))
    return [...value]

  return value ? [value] : []
}

export function restoreOptionCollection<TOption extends object>(
  options: TOption[],
  source: TOption | TOption[] | undefined,
): TOption | TOption[] | undefined {
  if (!options.length)
    return undefined

  return Array.isArray(source) ? options : options[0]
}
